import React from 'react';

const buildRotationItems = (widgetData) => {
  if (Array.isArray(widgetData)) {
    return widgetData
      .filter((item) => item?.LABEL != null && item?.RECORD != null)
      .map((item) => ({
        label: item.LABEL,
        value: item.RECORD,
      }));
  }

  if (widgetData?.LABEL != null && widgetData?.RECORD != null) {
    return [
      {
        label: widgetData.LABEL,
        value: widgetData.RECORD,
      },
    ];
  }

  return [];
};

const RotatingWidgetBody = ({ rotationItems, activeIndex }) => {
  const activeItem = rotationItems[activeIndex];

  return (
    <div className="widgetMid rotatingWidgetMid">
      {activeItem ? (
        <div className="rotatingWidgetItem">
          {activeItem.label && (
            <div className="rotatingWidgetLabel">
              {activeItem.label}
            </div>
          )}
          <div className="rotatingWidgetValue">
            {activeItem.value}
          </div>
        </div>
      ) : (
        <div className="widgetSingleValue">
          Unavailable
        </div>
      )}
    </div>
  );
};

export { buildRotationItems };
export default RotatingWidgetBody;
